import Main from "./Main.js";
import Pqp from "../3x1010/Pqp.js";

export default class Welcome {
	constructor(userLang, callback) {
		this.userLang = userLang;
		this.mc = undefined;
		this.callback = callback;
		this.canClose = false;
	}


	init(delay) {
		let mc = jQuery("#template-trix-welcome").clone();
		mc.attr("id", "welcome" + Welcome.ENUM++);
		jQuery(".js-trix1010").append(mc);

		mc.on("click", jQuery.proxy(this.dismiss, this))
		this.mc = mc;

		mc.css("opacity", 0);

		jQuery(".js-title", this.mc).html(Main.lbl("introTitolo"));
		jQuery(".js-subtitle", this.mc).html(Main.lbl("introDescrizione"));
		jQuery(".js-btn", this.mc).html(Main.lbl("continua"));


		if ((delay) && (delay > 0)) {
			setTimeout(jQuery.proxy(this.show, this), delay);
		} else {
			this.show();
		}
	}

	show() {
		Main.sfoca(true);
		TweenMax.to(this.mc, 0.5, {
			opacity: 1,
			onComplete: jQuery.proxy(this.canInteract, this)
		});

	}
	canInteract() {
		this.canClose = true;
	}
	dismiss() {
		if (this.canClose) {

			if (Pqp.isMobile()) {
				if (!Pqp.isIos()) {
					Main.that.toggleFullscreen();
				}
			}

			this.mc.off("click")
			TweenMax.to(this.mc, 0.5, {
				opacity: 0,
				onComplete: jQuery.proxy(this.remove, this)
			});
		}
	}

	remove() {
		this.mc.remove();
		this.callback.call();
	}
}

Welcome.ENUM = 0;